























































































































































































































import ContractHistory from '@/domain/contract-history/entity/contract-history.entity';
import DateHandler from '@/shared/utils/date-format';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import JustificationFileService from '@/domain/contract-history/service/justification-file.service';
import JustificationFile from '@/domain/contract-history/entity/justification-file.entity';

import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import toCurrencyNoSymbol from '@/shared/directive/toCurrencyNoSymbol';
import ManagementCalculationHistoryComponent from './management-calculation-history-content-component.vue';

@Component({
  components: {
    ManagementCalculationHistoryComponent,
  },
  filters: {
    formatDate(value: string) {
      return DateHandler.fullDateAndTime(value);
    },
    toCurrency: VbDirectives.toCurrency,
    formatDateOnly(value: string) {
      return DateHandler.timestampToLocal(value);
    },
    toCurrencyNoSymbol: (value: any) => toCurrencyNoSymbol(value),
  },
})

export default class HistoryContentComponent extends Vue {
  @Prop() selectedHistory?: ContractHistory;

  private loadingFile: boolean = false;

  @Watch('selectedHistory')
  content() {
    if (this.selectedHistory) {
      return ContractHistory.of(this.selectedHistory);
    }
    return {};
  }

  private downloadJustificationFile(): void {
    if (!this.selectedHistory) return;
    this.loadingFile = true;
    JustificationFileService.getById(this.selectedHistory.justificationFileId)
      .then((justificationFile: JustificationFile) => {
        const link = document.createElement('a');
        link.href = `data:${justificationFile.contentType};base64,${justificationFile.file}`;
        link.target = '_blank';
        link.download = justificationFile.fileName;
        link.click();
        window.URL.revokeObjectURL(link.href);
      }).catch(VbSnackbarService.handleHttpError)
      .finally(() => this.loadingFile = false);
  }
}
